import { memo, useState } from "react";
import { FormControl, FormHelperText, makeStyles, MenuItem, Select } from "@material-ui/core";

export const useStyles = makeStyles(() => ({
    root: {
        display: "flex",
        alignItems: "center",
    },
    popover: {
        marginTop: 2,
    },
    paper: {
        backgroundColor: "#1F2A37",
        color: "#D1D5DB",

        "& .MuiList-root .MuiMenuItem-root": {
            fontSize: "16px !important",
        },

        "& .MuiList-root .MuiMenuItem-root.Mui-selected": {
            backgroundColor: "#374151 !important",
        },

        "& .MuiList-root .MuiMenuItem-root:hover": {
            backgroundColor: "#374151 !important",
        },
    },
}));

/**
 * @see https://v4.mui.com/components/selects/
 */
const CustomSelect = ({ variant, label, customInputLabel, margin, name, handleBlur, handleChange, value, errors, touched, placeholder, required, disabled, InputProps, inputProps, style, readOnly, inheritLabel, helperText, error, children, helperTextStyle, displayEmpty }) => {
    const classes = useStyles();

    const [opened, setOpened] = useState(false);

    const hasError = name && errors && errors[name];

    return (
        <FormControl className="d-flex flex-column gap-8" style={{ margin: 0, marginTop: inheritLabel ? 24 : 0 }} error={error || (name && touched && errors) ? Boolean(touched[name] && errors[name]) : false}>
            {customInputLabel ??
                (label && !inheritLabel ? (
                    typeof label === "string" ? (
                        <span title={label} className="tt-14 medium color-dark-7 overflow-ellipsis w-100" htmlFor={name}>
                            {label}
                            {required ? <span className="color-red"> *</span> : ""}
                        </span>
                    ) : (
                        label
                    )
                ) : null)}

            <Select
                onOpen={() => setOpened(true)}
                onClose={() => setOpened(false)}
                displayEmpty
                variant={variant ?? "outlined"}
                required={required}
                label={inheritLabel && label ? label : null}
                margin={margin ?? "dense"}
                className="m-0"
                style={style}
                name={name}
                onBlur={handleBlur}
                onChange={handleChange}
                value={value}
                InputProps={InputProps}
                inputProps={inputProps}
                disabled={disabled}
                readOnly={readOnly}
                MenuProps={{
                    anchorOrigin: {
                        vertical: "bottom", // Dropdown will open below the input
                        horizontal: "left", // Align with the left of the input
                    },
                    transformOrigin: {
                        vertical: "top", // Ensure dropdown's top is at the bottom of the input
                        horizontal: "left", // Align dropdown with the input's left side
                    },
                    getContentAnchorEl: null,
                    PopoverClasses: {
                        root: classes.popover,
                        paper: classes.paper,
                    },
                }}
                classes={{ root: classes.root }}
            >
                {(placeholder || displayEmpty) && (
                    <MenuItem key="placeholder-option" value="" disabled={!displayEmpty}>
                        <span className={opened ? "" : "color-dark-5"}>{placeholder}</span>
                    </MenuItem>
                )}
                {children}
            </Select>

            {helperText || (name && touched && errors && touched[name] && errors[name]) ? <FormHelperText style={{ position: hasError ? "absolute" : undefined, bottom: hasError ? -20 : undefined, marginLeft: hasError ? 4 : undefined, ...helperTextStyle }}>{helperText ?? errors[name]}</FormHelperText> : null}
        </FormControl>
    );
};

export default memo(CustomSelect);
